/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";

export default function Footer(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px="30px"
      pb="20px"
    >
      <List display="flex">
        <ListItem>
          <Link
            color="gray.400"
            href="#license"
          >
            {document.documentElement.dir === "rtl" ? "رخصة" : "v0.9.8 - 2026"}
          </Link>
        </ListItem>
      </List>
    </Flex>
  );
}
